module.exports = __webpack_public_path__ + "media/images/pages/peel/peel-3-4b3538aa3fb5152caf997a29a25e8cbc.png";